import { instance } from '@/api/index';

function loginUser(userData) {
	return instance.post('/auth/login', userData);
}
function refreshUser(param) {
    return instance.get("/auth/refresh", { params: param });
}
export { loginUser,refreshUser };
